export function getQuery(key, lowercase = false, decode = true) {
    
    let url = window.location.search;
    if (decode) {
        url = decodeURIComponent(window.location.search);
    }

  if (lowercase) {
      url = url.toLowerCase();
      key = key.toLowerCase();
  }

  const query = new URLSearchParams(url);

  return query.get(key);
}

export const A = '';
